<h2 mat-dialog-title>{{ data.acceptMessage | translate }}</h2>

<mat-dialog-content>
  <ts-searchable-single-selector
    [options]="options$ | async"
    [loaded]="loaded$ | async"
    [hint]="'label.select_workspace' | translate"
    [noItemsMessage]="'text.no_compatible_workspaces' | translate"
    (selectedChange)="selectWorkspace($event.id?.toString())"
    (lastItemReached)="onLastItemReached()"
    (searchTermChanged)="searchWorkspace($event)"
  ></ts-searchable-single-selector>
</mat-dialog-content>

<mat-dialog-actions class="custom-dialog-actions justify-content-around">
  <button mat-dialog-close class="btn btn-outline-danger m-2 flex-grow-1" (click)="cancel()" data-cy="cancel-button">
    {{ 'button.cancel' | translate }}
  </button>
  <button
    mat-dialog-close
    class="btn m-2 flex-grow-1 widget btn-primary"
    color="primary"
    (click)="accept()"
    [disabled]="!readyToAccept"
    data-cy="confirm-button"
  >
    {{ data.acceptMessage | translate }}
  </button>
</mat-dialog-actions>
